const STORAGE_KEY = 'canRespondToIncidents';

export function persistCanRespondToIncidents(value) {
  localStorage.setItem(STORAGE_KEY, value ? 'true' : 'false');
}

export function readCanRespondToIncidents() {
  return localStorage.getItem(STORAGE_KEY) === 'true';
}

export function clearCanRespondToIncidents() {
  localStorage.removeItem(STORAGE_KEY);
}
